import { apiFetch } from "./api";
import { stringifySnake } from "./serialization";

export function fetchInsurances(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    search.append(key, value);
  });
  const suffix = search.toString() ? `?${search.toString()}` : "";
  return apiFetch(`/api/v1/insurances${suffix}`);
}

export function fetchInsurance(id) {
  return apiFetch(`/api/v1/insurances/${id}`);
}

export function createInsurance(payload) {
  return apiFetch("/api/v1/insurances", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateInsurance(id, payload) {
  return apiFetch(`/api/v1/insurances/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteInsurance(id) {
  return apiFetch(`/api/v1/insurances/${id}`, {
    method: "DELETE",
  });
}

export function fetchInsuranceDocuments(id) {
  return apiFetch(`/api/v1/insurances/${id}/documents`);
}

export function uploadInsuranceDocuments(id, documents) {
  return apiFetch(`/api/v1/insurances/${id}/documents`, {
    method: "POST",
    body: stringifySnake({ documents }),
  });
}

export function deleteInsuranceDocument(id, documentId) {
  return apiFetch(`/api/v1/insurances/${id}/documents/${documentId}`, {
    method: "DELETE",
  });
}
